import React, { useState, useEffect } from 'react';
import api from '../services/api';

const Changelog = () => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchChangelog = async () => {
            try {
                const text = await api.getChangelog();
                setContent(text);
            } catch (err) {
                setError('Не удалось загрузить журнал изменений');
            } finally {
                setLoading(false);
            }
        };
        fetchChangelog();
    }, []);

    return (
        <div className="page">
            <h2>Журнал изменений</h2>
            <div className="changelog-content-page">
                {loading && <p>Загрузка...</p>}
                {error && <p className="error-message">{error}</p>}
                {!loading && !error && (
                    <pre className="changelog-text">{content}</pre>
                )}
            </div>
        </div>
    );
};

export default Changelog;
